<div class="title">{{ titleText }}</div>
<div class="message">{{ messageText }}</div>
<div class="buttons-wrapper">
  <button class="button" (click)="retry()">
    {{ tryOneMoreTimeText }}
  </button>
  <button *ngIf="isMobile" class="button" (click)="backClick()">
    {{ backTOShelfText }}
  </button>
</div>
